"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { useDashboardTheme } from "@/components/dashboard/DashboardThemeProvider";
import { isDashboardAppearanceRoute } from "@/lib/utils/theme-scope";

/**
 * Applies classic dashboard CSS scope to portaled UI (modals, menus) on dashboard routes.
 */
export function DashboardAppearanceBodySync() {
  const pathname = usePathname();
  const { effectiveDashboardAppearance } = useDashboardTheme();

  useEffect(() => {
    if (typeof document === "undefined") return;

    if (!isDashboardAppearanceRoute(pathname)) {
      document.documentElement.removeAttribute("data-dashboard-appearance");
      document.body.removeAttribute("data-dashboard-appearance");
      return;
    }

    document.documentElement.setAttribute(
      "data-dashboard-appearance",
      effectiveDashboardAppearance,
    );
    document.body.setAttribute(
      "data-dashboard-appearance",
      effectiveDashboardAppearance,
    );

    return () => {
      document.documentElement.removeAttribute("data-dashboard-appearance");
      document.body.removeAttribute("data-dashboard-appearance");
    };
  }, [pathname, effectiveDashboardAppearance]);

  return null;
}
